import React from 'react';

const Budget = ({ Budget }) => {
  return (
    <div className='budget-container'>
      <div className='titles'>
        <h4>Rubro</h4>
        <h4>Monto</h4>
        <h4>Detalles</h4>
      </div>
      <div className='info'>
        {Budget.map((item, index) => (
          <>
            <p>{item.title}</p>
            <p>{item.amount}</p>
            <p>{item.details}</p>
          </>
        ))}
      </div>
    </div>
  );
};

export default Budget;
